// extracted by mini-css-extract-plugin
export default {"title":"MessageBox_title__8TUrM","content":"MessageBox_content__LVk3o","buttons":"MessageBox_buttons__8U7Gb"};